/* eslint-disable @typescript-eslint/no-unused-vars */
import { auth } from "firebase-config";
import { useNavigate } from "react-router-dom";

const useLogout = () => {
  const navigate = useNavigate();

  const logout = async () => {
    try {
      await auth.signOut();

      navigate("/login");
    } catch (error) {
      console.error(error);
    }
  };

  return logout;
};

export { useLogout };
